export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const START_PAGE = 1;
export const RESULTS_PER_PAGE = 10;
export const API_KEY = 'e596790d-d57a-46a6-98b3-a04ddf7803cc';              // please add your API_KEY here.API request is limited
export const MODAL_CLOSE_TIME_SEC = 2.5;
